import {
	createApp
} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus' //全局引入
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'normalize.css'

const app = createApp(App)
	.use(store)
	.use(ElementPlus, {
		locale: zhCn,
	})
	.use(router)

const debounce = (fn, delay) => {
  let timer
   return (...args) => {
     if (timer) {
       clearTimeout(timer)
     }
     timer = setTimeout(() => {
       fn(...args)
     }, delay)
   }
}
  
const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver{
   constructor(callback) {
     callback = debounce(callback, 200);
     super(callback);
   }
}

// 请求地址
import urls from '../api/api.js'
app.config.globalProperties.$urls = urls

// 请求方法
import request from '../api/request.js'
app.config.globalProperties.$request = request
// 弹窗
import tips from '../config/Tips.js'
app.config.globalProperties.$tips = tips	
	
app.mount('#app')
